module.exports = __webpack_public_path__ + "static/camden-0cff7ce4a0faccb7a56accd029fad202.png";